export default __webpack_public_path__ + "static/media/SN-API.95fb0bf3.png";